export default function (price, discount) {
  if (discount > 0) {
    return price * parseFloat(discount) / 100
  }
  return 0
}